import { QrScanner } from '@yudiel/react-qr-scanner';
import { useEffect, useState } from 'react';

import { Box } from '@/components/Box';
import { LegacyButton } from '@/components/LegacyButton';
import { Modal } from '@/components/Modal';
import { useIsMdDown } from '@/hooks/useMedia';

import { externalLinkReg } from '../Card/components/CTA';
import * as S from './GetMyNFTModal.style';

import * as M from './messages';

interface GetMyNFTModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const GetMyNFTModal = ({ isOpen, onClose }: GetMyNFTModalProps) => {
  const [value, setValue] = useState<string>('');
  const isMobileView = useIsMdDown();

  useEffect(() => {
    const isExternalLink = externalLinkReg.test(value);
    if (isExternalLink) {
      window.location.href = value;
    }
  }, [value]);

  return (
    <S.Modal
      data-test-id='GetMyNFTModal-Modal'
      gutters={false}
      isOpen={isOpen}
      maxWidth='xs'
      onClose={onClose}
      screenClose={true}
    >
      <Modal.Header data-test-id='GetMyNFTModal-ModalHeader' onClose={onClose}>
        {M.getMyNFTTitle}
      </Modal.Header>
      <S.ModalBody data-test-id='GetMyNFTModal-ModalBody'>
        <Box>
          {isMobileView ? (
            <>
              <S.Desc>{M.ScanQrCodeOnWarrantyCard}</S.Desc>
              <QrScanner
                constraints={{ facingMode: 'environment' }}
                containerStyle={{
                  background: '#000000',
                }}
                data-test-id='QrScannerWrapper'
                onDecode={(result) => {
                  setValue(result);
                }}
                onError={(error) => console.log(error?.message)}
                videoStyle={{
                  objectFit: 'cover',
                }}
              />
            </>
          ) : (
            <S.Desc>{M.getMyNFTDesc(onClose)}</S.Desc>
          )}
        </Box>
      </S.ModalBody>
      <S.ModalFooter>
        <LegacyButton
          label='My watches'
          linkProps={{ href: '/my-account/my-watches/' }}
          onClick={() => {
            onClose();
          }}
          style={{ maxWidth: '20%', margin: '0 auto' }}
        />
      </S.ModalFooter>
    </S.Modal>
  );
};
